import { isString } from 'util';

export const getCognitoConfig = (config) => ({
    region: config.NEXT_COGNITO_REGION,
    userPoolId: config.NEXT_COGNITO_USER_POOL_ID,
    userPoolWebClientId: config.NEXT_COGNITO_USER_POOL_WEB_CLIENT_ID,
    mandatorySignIn: true,
    authenticationFlowType: config.NEXT_COGNITO_AUTH_FLOW,
    cookieStorage: {
        domain: config.NEXT_COGNITO_COOKIE_DOMAIN,
        path: '/',
        secure: config.NOV_MODE !== 'development', // production => true,
        expires: isString(config.NEXT_COGNITO_COOKIE_EXPIRES) ? Number(config.NEXT_COGNITO_COOKIE_EXPIRES) : 1
    }
});
